import baseUrl from './baseUrl';

const URL_UPDATE_VESTUARIO = `${baseUrl}/vestuario`;

const updateVestuario = async vestuarioData => {
  try {
    const data = await fetch(URL_UPDATE_VESTUARIO, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(vestuarioData)
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default updateVestuario;
